__turbopack_context__.v({
  "arrow": "showroom-modal-module__d9rJiW__arrow",
  "blok-big-title": "showroom-modal-module__d9rJiW__blok-big-title",
  "blok-subtitle": "showroom-modal-module__d9rJiW__blok-subtitle",
  "blok-title": "showroom-modal-module__d9rJiW__blok-title",
  "button": "showroom-modal-module__d9rJiW__button",
  "content": "showroom-modal-module__d9rJiW__content",
  "wrapper": "showroom-modal-module__d9rJiW__wrapper",
});
